import { GET_ASSIGNMENT_SUCCEEDED, GET_CHAPTERS_SUCCEEDED } from '../actions/Constants';

const initialState = {
  weeklyStatus: [],
  weeks: [],
  dailyData: [],
  chapters: [],
  assignments: [],
};

function dashbaordReducer(state = initialState, action) {
  switch (action.type) {
    case 'SEARCH_WEEK_FULFILLED': {
      return Object.assign({}, state, {
        weeks: action.payload
      });
    }

    case 'SEARCH_DAY_FULFILLED': {
      return Object.assign({}, state, {
        dailyData: action.payload
      });
    }

    case 'SET_CONTENT': {
      return Object.assign({}, state, {
        weeks: []
      });
    }

    case GET_CHAPTERS_SUCCEEDED: {
      return Object.assign({}, state, {
        chapters: action.payload
      });
    }

    case GET_ASSIGNMENT_SUCCEEDED: {
      return Object.assign({}, state, {
        assignments: action.payload
      });
    }

    default:
      return state;
  }
}

export default dashbaordReducer;



// WEBPACK FOOTER //
// ./src/reducers/DashboardReducer.js